<div class="container">
  <div class="row mt-5 mb-5">
    <div class="col-sm-12">
      <h1 class="mat-headline-4">{{'*.accessDenied' | translate}}</h1>
    </div>
    <div class="col-sm-12">
      You have no permissions to use the H+ Sample Backend Portal. Please contact the administrators of the H+ Sample
      Backend portal.
    </div>
  </div>
</div>